"use strict";

(() => {
	class Leasing_Calculator {
		/** @var {HTMLElement} */
		#$widget;

		/** @var {HTMLInputElement} */
		#$priceInput;

		/** @var {HTMLInputElement} */
		#$downPaymentInput;

		/** @var {HTMLInputElement} */
		#$paymentsCountInput;

		/** @var {HTMLInputElement} */
		#$interestInput;

		/** @var {HTMLElement} */
		#$result;


		constructor($widget) {
			this.#$widget = $widget;
		}

		initialize() {
			// Initialite selectors.
			this.#$priceInput         = this.#$widget.querySelector(".dan-input-price");
			this.#$downPaymentInput   = this.#$widget.querySelector(".dan-input-down-payment");
			this.#$paymentsCountInput = this.#$widget.querySelector(".dan-input-payments-count");
			this.#$interestInput      = this.#$widget.querySelector(".dan-input-interest");
			this.#$result             = this.#$widget.querySelector(".dan-result");

			// Add handlers to events,
			this.#$widget.addEventListener("submit", (this.#onFormSubmit).bind(this));

			// Initialize quantity inputs.
			const $quantityGroups = this.#$widget.querySelectorAll(".dan-quantity-group");

			for (const $quantityGroup of $quantityGroups) {
				$quantityGroup.quantityInput = new Dan_QuantityInput($quantityGroup);
				$quantityGroup.quantityInput.initialize();
			}

			// Initialize tooltips.
			const $tooltips = this.#$widget.querySelectorAll("[data-tooltip]");

			if ($tooltips.length > 0) {
				// noinspection JSUnresolvedReference
				tippy($tooltips, {
					content: ($element) => $element.getAttribute("data-tooltip"),
					allowHTML: true
				});
			}
		}

		#onFormSubmit(event) {
			event.preventDefault();
			const inputs = this.getInputs();

			// Check inputs.
			if (
				inputs.price === null
				|| inputs.downPayment === null
				|| inputs.paymentsCount === null
				|| inputs.interest === null
			) {
				alert("Prosím, zkontrolujte, zda jste zadali správně všechny hodnoty.");
				return;
			}

			// Calc.
			const downPayment = Math.round(inputs.price * (inputs.downPayment / 100));
			const loan        = (inputs.price - downPayment);
			const payment     = Math.round(
				(loan * (inputs.interest / 100 / 12))
				/ (1 - Math.pow(1 + (inputs.interest / 100 / 12), -inputs.paymentsCount))
			);

			let coefficient = (
				(downPayment + (payment * inputs.paymentsCount))
				/ inputs.price
			);

			coefficient = (Math.round(coefficient * 100) / 100);

			this.#setResult(payment, downPayment, coefficient);
		}

		#setResult(payment, downPayment, coefficient) {
			if (this.#$result.classList.contains("-active")) {
				this.#slideResultUp(() => {
					this.#setResultValues(payment, downPayment, coefficient);
					this.#slideResultDown();
				});
			} else {
				this.#setResultValues(payment, downPayment, coefficient);
				this.#slideResultDown();
			}
		}

		#setResultValues(payment, downPayment, coefficient) {
			const $payment     = this.#$result.querySelector(".-result-payment");
			const $downPayment = this.#$result.querySelector(".-result-down-payment");
			const $coefficient = this.#$result.querySelector(".-result-coefficient");

			$payment.textContent      = Dan_Utilities.formatPrice(payment) + " Kč";
			$downPayment.textContent  = Dan_Utilities.formatPrice(downPayment) + " Kč";
			$coefficient.textContent  = (Math.round(coefficient * 100) / 100);
		}

		#slideResultUp(callback = null) {
			this.#$result.style.height = this.#$result.scrollHeight + "px";

			setTimeout(() => {
				this.#$result.style.height = "0";
			}, 25);

			setTimeout(() => {
				this.#$result.classList.remove("-active");

				if (typeof callback === "function") {
					callback();
				}
			}, 175);
		}

		#slideResultDown(callback = null) {
			this.#$result.style.height = this.#$result.scrollHeight + "px";

			setTimeout(() => {
				this.#$result.style.height = "auto";
				this.#$result.classList.add("-active");

				if (typeof callback === "function") {
					callback();
				}
			}, 150);
		}

		getInputs() {
			// Price.
			let price;
			price = this.#$priceInput.value || this.#$priceInput.placeholder;
			price = parseInt(price);

			if (isNaN(price) || price < 0) {
				price = null;
			}

			// Down payment.
			let downPayment;
			downPayment = this.#$downPaymentInput.value || this.#$downPaymentInput.placeholder;
			downPayment = parseFloat(downPayment);

			if (isNaN(downPayment) || downPayment < 0 || downPayment > 99.9) {
				downPayment = null;
			}

			// Payments count.
			let paymentsCount = parseInt(this.#$paymentsCountInput.value);

			if (isNaN(paymentsCount) || paymentsCount < 1) {
				paymentsCount = null;
			}

			// Interest.
			let interest;
			interest = this.#$interestInput.value || this.#$interestInput.placeholder;
			interest = parseFloat(interest);

			if (isNaN(interest) || interest < 0) {
				interest = null;
			}

			// Return.
			return {
				price,
				downPayment,
				paymentsCount,
				interest
			};
		}
	}

	// Initialize widgets.
	const $widgets = document.querySelectorAll(".dan-leasing-calculator");

	for (const $widget of $widgets) {
		$widget.calculator = new Leasing_Calculator($widget);
		$widget.calculator.initialize();
	}
})();
